import React, { useState } from "react";
import { IoFunnel } from "react-icons/io5";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { Collapse, Row, Col, Well } from "react-bootstrap";
import Formsy from "formsy-react";

import HeaderWrapper from "../../common/HeaderWrapper";

const ReportFilters = ({
  onFetchClick,
  onResetClick,
  title,
  isMobile,
  loading,
  children,
  disabled,
  csvExportAvailable,
  pdfExportAvailable,
  onCSVExport,
  onPDFExport,
  exportDisabled,
  exporting
}) => {
  const [filtersOpen, setFiltersOpen] = useState(true);
  const auth = useSelector((state) => state.reducers.auth);

  const actions = [
    {
      action: () => setFiltersOpen(!filtersOpen),
      icon: <IoFunnel />
    }
  ];

  if (csvExportAvailable) {
    actions.push({
      action: () => onCSVExport(),
      className: "btn-success",
      text: "CSV",
      disabled: exportDisabled
    });
  }

  if (pdfExportAvailable) {
    actions.push({
      action: () => onPDFExport(),
      className: "btn-danger",
      text: exporting ? "Exporting..." : "PDF",
      disabled: exportDisabled
    });
  }

  return (
    <React.Fragment>
      <HeaderWrapper
        breadcrumbs={[
          {
            label: title
          }
        ]}
        isMobile={isMobile}
        onClickAction={actions}
      />
      <Collapse
        in={filtersOpen}
        className="filter-container"
        style={{
          marginLeft: 15,
          marginRight: 15,
          backgroundColor: auth.isNightMode ? "#1a2129" : "#f2f3f8",
          border: "none"
        }}
      >
        <Well>
          <Formsy className="vertical form">
            {children}
            <Row>
              <Col md={12}>
                <button
                  className="btn btn-warning"
                  type="button"
                  onClick={onResetClick}
                  disabled={loading}
                >
                  Reset
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={onFetchClick}
                  disabled={loading || disabled}
                >
                  Fetch Data
                </button>
              </Col>
            </Row>
          </Formsy>
        </Well>
      </Collapse>
    </React.Fragment>
  );
};

ReportFilters.propTypes = {
  onResetClick: PropTypes.func,
  onFetchClick: PropTypes.func,
  title: PropTypes.string,
  isMobile: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  csvExportAvailable: PropTypes.bool,
  pdfExportAvailable: PropTypes.bool,
  onCSVExport: PropTypes.func,
  onPDFExport: PropTypes.func,
  exportDisabled: PropTypes.bool,
  exporting: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    exporting: state.reducers.exporting
  };
}

export default connect(mapStatesToProps, null)(ReportFilters);
